import * as React from 'react';
import { useSelector } from 'react-redux';

import { Filter, Filters } from '../components';
import { STATUS_ALL } from '../../../store/offerHistory';
import {
  selectActiveRoomsFilter,
  selectActiveStatusFilter,
  selectRoomsFilters,
  selectStatusFilters,
} from '../../../store/offerHistory/selectors';
import { useHandleRoomsFiltersClick } from './utils/useHandleRoomsFiltersClick';
import { useHandleStatusFiltersClick } from './utils/useHandleStatusFiltersClick';

/**
 * Контейнер собирает блок фильтров
 *   * фильтры статусов
 *   * фильтры комнат
 * Если по какому-то отдельному фильтру данных нет - он не будет отрендерен
 * */
export const FiltersContainer: React.FC = () => {
  const statusFilters = useSelector(selectStatusFilters);
  const roomsFilters = useSelector(selectRoomsFilters);
  const statusFiltersActiveIDs = useSelector(selectActiveStatusFilter);
  const roomsFiltersActiveIDs = useSelector(selectActiveRoomsFilter);
  const handleRoomsFiltersClick = useHandleRoomsFiltersClick();
  const handleStatusFiltersClick = useHandleStatusFiltersClick();

  if (!statusFilters && !roomsFilters) {
    return null;
  }

  return (
    <Filters>
      {statusFilters && (
        <Filter
          items={statusFilters}
          activeIDs={statusFiltersActiveIDs || [STATUS_ALL]}
          onClick={handleStatusFiltersClick}
          title="Статус объявлений"
        />
      )}
      {roomsFilters && (
        <Filter
          items={roomsFilters}
          activeIDs={roomsFiltersActiveIDs || [STATUS_ALL]}
          onClick={handleRoomsFiltersClick}
          title="Количество комнат"
        />
      )}
    </Filters>
  );
};

FiltersContainer.displayName = 'FiltersContainer';
